export const XLSX_SOURCE_COLUMNS = Symbol.for('synapse.xlsx.sourceColumns');

export const attachXlsxSourceColumns = (row, sourceColumns) => {
	Object.defineProperty(row, XLSX_SOURCE_COLUMNS, {
		value: sourceColumns,
		enumerable: false,
	});
	return row;
};

export const getXlsxSourceColumns = row => row?.[XLSX_SOURCE_COLUMNS];
